import { MFAForm } from '../../components/MFAForm';

export function MFA() {
  return <MFAForm />;
}
